export var toggleSort = function toggleSort(sortBy, isAscending, entity) {
  if (sortBy === entity && typeof isAscending !== 'undefined') {
    return !isAscending ? 'desc' : 'asc';
  }

  return '';
};
export var toggleOrder = function toggleOrder(orderBy) {
  var orderAndDirection = orderBy.split(' ');

  if (orderBy === orderAndDirection[0]) {
    if (orderAndDirection[1] === 'DESC') {
      return 'asc';
    }

    if (orderAndDirection[1] === 'ASC') {
      return 'desc';
    }
  }

  return '';
};
export var clearCheckboxes = function clearCheckboxes() {
  var checkbox = document.querySelectorAll('.checked input[type="checkbox"]');
  checkbox.forEach(function (item) {
    item.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  });
};
export default {};